import React, { useState } from 'react';
import IssueCertificate from './IssueCertificate';
import ViewCertificates from './ViewCertificates';
import './UserCertificates.css';

type SubTabType = 'issue' | 'view';

const UserCertificates: React.FC = () => {
  const [activeSubTab, setActiveSubTab] = useState<SubTabType>('issue');

  const subTabs = [
    { id: 'issue' as SubTabType, label: 'Issue Certificate' },
    { id: 'view' as SubTabType, label: 'View Certificates' },
  ];

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case 'issue':
        return <IssueCertificate onSuccess={() => setActiveSubTab('view')} />;
      case 'view':
        return <ViewCertificates />;
      default:
        return <IssueCertificate onSuccess={() => setActiveSubTab('view')} />;
    }
  };

  return (
    <div className="admin-user-certificates">
      <div className="admin-user-certificates-header">
        <h2>User Certificates</h2>
        <p>Issue and manage certificates for individual users</p>
      </div>

      <div className="admin-user-certificates-sub-tabs">
        {subTabs.map((tab) => (
          <button
            key={tab.id}
            className={`admin-user-certificates-sub-tab ${
              activeSubTab === tab.id ? 'admin-user-certificates-sub-tab-active' : ''
            }`}
            onClick={() => setActiveSubTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="admin-user-certificates-content">{renderSubTabContent()}</div>
    </div>
  );
};

export default UserCertificates;
